<!--eslint-disable-->
<template>
  <div class="logo-container" :class="{'is-collapse': isCollapse}">
    <div class="logo-1">
      <img :src="logo1"/>
    </div>
    <div v-if="!isCollapse" class="logo-2">
      <img :src="logo2"/>
    </div>
  </div>
</template>

<script>
import logo1Dark from '@/assets/images/Head/soloing_logo_1_dark.png';
import logo2Dark from '@/assets/images/Head/soloing_logo_2_dark.png';
import logo1Light from '@/assets/images/Head/soloing_logo_1_light.png';
import logo2Light from '@/assets/images/Head/soloing_logo_2_light.png';

import { mapGetters, mapState } from 'vuex';

/* eslint-disable */
export default {
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    }),
    logo1() {
      return this.userInfo.skin === 1 ? logo1Dark : logo1Light
    },
    logo2() {
      return this.userInfo.skin === 1 ? logo2Dark : logo2Light
    },
    ...mapGetters([
      'sidebar'
    ]),
    isCollapse() {
      return !this.sidebar.opened;
    }
  }
}
</script>
<style lang="scss" scoped>
.logo-container {
  padding: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .logo-1 {
    width: 61px;
    height: 62px;
    margin-bottom: 10px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .logo-2 {
    width: 110px;
    height: 17px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &.is-collapse {
    .logo-1 {
      width: 41px;
      height: 42px;
    }
  }
}
</style>
